import Particles from "react-tsparticles";
import React,{useState,useEffect} from 'react';

function ParticleMotion(props){
    const containerRef = React.useRef();

    const particlesInit = (main) => {
        console.log(main);
    
        // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
      };
    
      const particlesLoaded = (container) => {
        console.log(container);

        if (props.stopped){
            container.stop();
        }
        else if(!props.stopped){
            container.play();
        }
      };

      var bgColor = "#fff";
      var fgColor = "#999";
      if (props.theme == "dark"){
          bgColor = "#000";
          fgColor = "#D3D3D3";
      }

      if (containerRef && containerRef.current){
        containerRef.current.stop();
      }
      
      if (props.bgType == "starconnect"){
        return (
          <Particles
          className="particles"
          container={containerRef}
          id="tsparticles"
          init={particlesInit}
          loaded={particlesLoaded}
          options={{
            background: {
              color: {
                value: bgColor,
              },
            },
            fpsLimit: 60,
            interactivity: {
              events: {
                onClick: {
                  enable: true,
                  mode: "repulse",
                },
                onHover: {
                  enable: true,
                  mode: "trail",
                  "parallax": {
                    "enable": false,
                    "force": 2,
                    "smooth": 10
                  }
                },
                resize: true,
              },
              modes: {
                bubble: {
                  distance: 400,
                  duration: 2,
                  opacity: 0.8,
                  size: 40,
                },
                push: {
                  quantity: 4,
                },
                repulse: {
                  distance: 80,
                  duration: 0.5,
                },
                trail: {
                    delay: 0.005,
                    pauseOnStop: true,
                    quantity: 1,
                    particles: {
                      color: {
                        value: "#ff0000",
                        animation: {
                          enable: true,
                          speed: 400,
                          sync: true
                        }
                      },
                      collisions: {
                        enable: false,
                        bounce: {
                          horizontal: {
                            random: {}
                          },
                          vertical: {
                            random: {}
                          }
                        },
                        overlap: {}
                      },
                      links: {
                        enable: false,
                        shadow: {},
                        triangles: {}
                      },
                      move: {
                        outModes: {
                          default: "destroy"
                        },
                        speed: 1,
                        angle: {},
                        attract: {
                          rotate: {}
                        },
                        distance: {},
                        gravity: {},
                        path: {
                          delay: {
                            random: {}
                          }
                        },
                        trail: {}
                      },
                      size: {
                        value: 5,
                        animation: {
                          enable: true,
                          speed: 5,
                          minimumValue: 1,
                          sync: true,
                          startValue: "min",
                          destroy: "max"
                        },
                        random: {}
                      },
                      bounce: {
                        horizontal: {
                          random: {}
                        },
                        vertical: {
                          random: {}
                        }
                      },
                      destroy: {
                        split: {
                          factor: {
                            random: {}
                          },
                          rate: {
                            random: {}
                          }
                        }
                      },
                      life: {
                        delay: {
                          random: {}
                        },
                        duration: {
                          random: {}
                        }
                      },
                      number: {
                        density: {}
                      },
                      opacity: {
                        animation: {},
                        random: {}
                      },
                      roll: {
                        darken: {},
                        enlighten: {}
                      },
                      rotate: {
                        animation: {}
                      },
                      shadow: {
                        offset: {}
                      },
                      shape: {},
                      stroke: {
                        color: {
                          value: "",
                          animation: {
                            count: 0,
                            enable: false,
                            offset: {
                              max: 0,
                              min: 0
                            },
                            speed: 0,
                            sync: false
                          }
                        }
                      },
                      tilt: {
                        animation: {}
                      },
                      twinkle: {
                        lines: {},
                        particles: {}
                      },
                      wobble: {}
                    }
                  }
              },
            },
            particles: {
              color: {
                value: '#92b4f2',
              },
              links: {
                color: '#92b4f2',
                distance: 150,
                enable: true,
                opacity: 0.5,
                width: 1,
              },
              collisions: {
                enable: false,
              },
              move: {
                direction: "none",
                enable: true,
                outMode: "out",
                bounce: false,
                random: false,
                speed: 1,
                straight: false,
              },
              number: {
                density: {
                  enable: true,
                  value_area: 800,
                },
                value: 80,
              },
              opacity: {
                value: 0.5,
              },
              shape: {
                type: "circle",
              },
              size: {
                random: true,
                value: 5,
              },
            },
            detectRetina: true,
          }}
        />
        )
      }
      else if (props.bgType == "star"){
        return (
          <Particles
          container={containerRef}
          id="tsparticles"
          init={particlesInit}
          loaded={particlesLoaded}
          options={{
            background: {
              color: {
                value: bgColor,
              },
            },
            fpsLimit: 60,
            interactivity: {
              events: {
                onClick: {
                  enable: true,
                  mode: "repulse",
                },
                onHover: {
                  enable: true,
                  mode: "trail",
                  "parallax": {
                    "enable": false,
                    "force": 2,
                    "smooth": 10
                  }
                },
                resize: true,
              },
              modes: {
                bubble: {
                  distance: 400,
                  duration: 2,
                  opacity: 0.8,
                  size: 40,
                },
                push: {
                  quantity: 4,
                },
                repulse: {
                  distance: 80,
                  duration: 0.5,
                },
                trail: {
                    delay: 0.005,
                    pauseOnStop: true,
                    quantity: 1,
                    particles: {
                      color: {
                        value: "#ff0000",
                        animation: {
                          enable: true,
                          speed: 400,
                          sync: true
                        }
                      },
                      collisions: {
                        enable: false,
                        bounce: {
                          horizontal: {
                            random: {}
                          },
                          vertical: {
                            random: {}
                          }
                        },
                        overlap: {}
                      },
                      links: {
                        enable: false,
                        shadow: {},
                        triangles: {}
                      },
                      move: {
                        outModes: {
                          default: "destroy"
                        },
                        speed: 1,
                        angle: {},
                        attract: {
                          rotate: {}
                        },
                        distance: {},
                        gravity: {},
                        path: {
                          delay: {
                            random: {}
                          }
                        },
                        trail: {}
                      },
                      size: {
                        value: 5,
                        animation: {
                          enable: true,
                          speed: 5,
                          minimumValue: 1,
                          sync: true,
                          startValue: "min",
                          destroy: "max"
                        },
                        random: {}
                      },
                      bounce: {
                        horizontal: {
                          random: {}
                        },
                        vertical: {
                          random: {}
                        }
                      },
                      destroy: {
                        split: {
                          factor: {
                            random: {}
                          },
                          rate: {
                            random: {}
                          }
                        }
                      },
                      life: {
                        delay: {
                          random: {}
                        },
                        duration: {
                          random: {}
                        }
                      },
                      number: {
                        density: {}
                      },
                      opacity: {
                        animation: {},
                        random: {}
                      },
                      roll: {
                        darken: {},
                        enlighten: {}
                      },
                      rotate: {
                        animation: {}
                      },
                      shadow: {
                        offset: {}
                      },
                      shape: {},
                      stroke: {
                        color: {
                          value: "",
                          animation: {
                            count: 0,
                            enable: false,
                            offset: {
                              max: 0,
                              min: 0
                            },
                            speed: 0,
                            sync: false
                          }
                        }
                      },
                      tilt: {
                        animation: {}
                      },
                      twinkle: {
                        lines: {},
                        particles: {}
                      },
                      wobble: {}
                    }
                  }
              },
            },
            particles: {
              color: {
                value: '#92b4f2',
              },
              links: {
                color: '#92b4f2',
                distance: 150,
                enable: false,
                opacity: 0.5,
                width: 1,
              },
              collisions: {
                enable: false,
              },
              move: {
                direction: "none",
                enable: true,
                outMode: "out",
                bounce: false,
                random: false,
                speed: 1,
                straight: false,
              },
              number: {
                density: {
                  enable: true,
                  value_area: 800,
                },
                value: 80,
              },
              opacity: {
                value: 0.5,
              },
              shape: {
                type: "circle",
              },
              size: {
                random: true,
                value: 5,
              },
            },
            detectRetina: true,
          }}
        />
        )
      }
      else if(props.bgType == "static"){
        return(
        <Particles
          container={containerRef}
          id="tsparticles"
          init={particlesInit}
          loaded={particlesLoaded}
          options={{
            background: {
              color: {
                value: bgColor,
              },
            },
            fpsLimit: 60,
            interactivity: {
              events: {
                onClick: {
                  enable: true,
                  mode: "repulse",
                },
                onHover: {
                  enable: true,
                  mode: "trail",
                  "parallax": {
                    "enable": false,
                    "force": 2,
                    "smooth": 10
                  }
                },
                resize: true,
              },
              modes: {
                bubble: {
                  distance: 400,
                  duration: 2,
                  opacity: 0.8,
                  size: 40,
                },
                push: {
                  quantity: 4,
                },
                repulse: {
                  distance: 80,
                  duration: 0.5,
                },
                trail: {
                    delay: 0.005,
                    pauseOnStop: true,
                    quantity: 1,
                    particles: {
                      color: {
                        value: "#ff0000",
                        animation: {
                          enable: true,
                          speed: 400,
                          sync: true
                        }
                      },
                      collisions: {
                        enable: false,
                        bounce: {
                          horizontal: {
                            random: {}
                          },
                          vertical: {
                            random: {}
                          }
                        },
                        overlap: {}
                      },
                      links: {
                        enable: false,
                        shadow: {},
                        triangles: {}
                      },
                      move: {
                        direction: "none",
                        enable: true,
                        outMode: "out",
                        bounce: false,
                        random: false,
                        speed: 1,
                        straight: false,
                      },
                      size: {
                        value: 5,
                        animation: {
                          enable: true,
                          speed: 5,
                          minimumValue: 1,
                          sync: true,
                          startValue: "min",
                          destroy: "max"
                        },
                        random: {}
                      },
                      bounce: {
                        horizontal: {
                          random: {}
                        },
                        vertical: {
                          random: {}
                        }
                      },
                      destroy: {
                        split: {
                          factor: {
                            random: {}
                          },
                          rate: {
                            random: {}
                          }
                        }
                      },
                      life: {
                        delay: {
                          random: {}
                        },
                        duration: {
                          random: {}
                        }
                      },
                      number: {
                        density: {}
                      },
                      opacity: {
                        animation: {},
                        random: {}
                      },
                      roll: {
                        darken: {},
                        enlighten: {}
                      },
                      rotate: {
                        animation: {}
                      },
                      shadow: {
                        offset: {}
                      },
                      shape: {},
                      stroke: {
                        color: {
                          value: "",
                          animation: {
                            count: 0,
                            enable: false,
                            offset: {
                              max: 0,
                              min: 0
                            },
                            speed: 0,
                            sync: false
                          }
                        }
                      },
                      tilt: {
                        animation: {}
                      },
                      twinkle: {
                        lines: {},
                        particles: {}
                      },
                      wobble: {}
                    }
                  }
              },
            },
            particles: {
              color: {
                value: '#92b4f2',
              },
              links: {
                color: '#92b4f2',
                distance: 150,
                enable: true,
                opacity: 0.5,
                width: 1,
              },
              collisions: {
                enable: false,
              },
              move: {
                direction: "none",
                enable: false,
                outMode: "out",
                bounce: false,
                random: false,
                speed: 1,
                straight: false,
              },
              number: {
                density: {
                  enable: true,
                  value_area: 800,
                },
                value: 80,
              },
              opacity: {
                value: 0.5,
              },
              shape: {
                type: "circle",
              },
              size: {
                random: true,
                value: 4,
              },
            },
            detectRetina: true,
          }}
        />
        )
      }
      else if (props.bgType == "fireworks"){
        return (
          <Particles
          container={containerRef}
          id="tsparticles"
          init={particlesInit}
          loaded={particlesLoaded}
          options={{
            "autoPlay": true,
            "background": {
              "color": {
                "value": "#000"
              },
              "image": "",
              "position": "",
              "repeat": "",
              "size": "",
              "opacity": 1
            },
            "backgroundMask": {
              "composite": "destination-out",
              "cover": {
                "color": {
                  "value": "#fff"
                },
                "opacity": 1
              },
              "enable": false
            },
            "fullScreen": {
              "enable": true,
              "zIndex": 0
            },
            "detectRetina": true,
            "duration": 0,
            "fpsLimit": 60,
            "interactivity": {
              "detectsOn": "window",
              "events": {
                "onClick": {
                  "enable": false,
                  "mode": []
                },
                "onDiv": {
                  "selectors": [],
                  "enable": false,
                  "mode": [],
                  "type": "circle"
                },
                "onHover": {
                  "enable": false,
                  "mode": [],
                  "parallax": {
                    "enable": false,
                    "force": 2,
                    "smooth": 10
                  }
                },
                "resize": true
              },
              "modes": {
                "attract": {
                  "distance": 200,
                  "duration": 0.4,
                  "easing": "ease-out-quad",
                  "factor": 1,
                  "maxSpeed": 50,
                  "speed": 1
                },
                "bounce": {
                  "distance": 200
                },
                "bubble": {
                  "distance": 200,
                  "duration": 0.4,
                  "mix": false
                },
                "connect": {
                  "distance": 80,
                  "links": {
                    "opacity": 0.5
                  },
                  "radius": 60
                },
                "grab": {
                  "distance": 100,
                  "links": {
                    "blink": false,
                    "consent": false,
                    "opacity": 1
                  }
                },
                "light": {
                  "area": {
                    "gradient": {
                      "start": {
                        "value": "#ffffff"
                      },
                      "stop": {
                        "value": "#000000"
                      }
                    },
                    "radius": 1000
                  },
                  "shadow": {
                    "color": {
                      "value": "#000000"
                    },
                    "length": 2000
                  }
                },
                "push": {
                  "default": true,
                  "groups": [],
                  "quantity": 4
                },
                "remove": {
                  "quantity": 2
                },
                "repulse": {
                  "distance": 200,
                  "duration": 0.4,
                  "factor": 100,
                  "speed": 1,
                  "maxSpeed": 50,
                  "easing": "ease-out-quad"
                },
                "slow": {
                  "factor": 3,
                  "radius": 200
                },
                "trail": {
                  "delay": 1,
                  "pauseOnStop": false,
                  "quantity": 1,
                  "particles": {
                    "color": {
                      "value": "#ff0000",
                      "animation": {
                        "enable": true,
                        "speed": 400,
                        "sync": true
                      }
                    },
                    "collisions": {
                      "enable": false
                    },
                    "links": {
                      "enable": false
                    },
                    "move": {
                      "outModes": {
                        "default": "destroy"
                      },
                      "speed": 2
                    },
                    "size": {
                      "value": 5,
                      "animation": {
                        "enable": true,
                        "speed": 5,
                        "minimumValue": 1,
                        "sync": true,
                        "startValue": "min",
                        "destroy": "max"
                      }
                    }
                  }
                }
              }
            },
            "manualParticles": [],
            "motion": {
              "disable": false,
              "reduce": {
                "factor": 4,
                "value": true
              }
            },
            "particles": {
              "bounce": {
                "horizontal": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0.1
                  },
                  "value": 1
                },
                "vertical": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0.1
                  },
                  "value": 1
                }
              },
              "collisions": {
                "bounce": {
                  "horizontal": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0.1
                    },
                    "value": 1
                  },
                  "vertical": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0.1
                    },
                    "value": 1
                  }
                },
                "enable": false,
                "mode": "bounce",
                "overlap": {
                  "enable": true,
                  "retries": 0
                }
              },
              "color": {
                "value": "#fff",
                "animation": {
                  "h": {
                    "count": 0,
                    "enable": false,
                    "offset": 0,
                    "speed": 1,
                    "sync": true
                  },
                  "s": {
                    "count": 0,
                    "enable": false,
                    "offset": 0,
                    "speed": 1,
                    "sync": true
                  },
                  "l": {
                    "count": 0,
                    "enable": false,
                    "offset": 0,
                    "speed": 1,
                    "sync": true
                  }
                }
              },
              "destroy": {
                "mode": "split",
                "split": {
                  "count": 1,
                  "factor": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0
                    },
                    "value": 0.333333
                  },
                  "rate": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0
                    },
                    "value": 100
                  },
                  "sizeOffset": true,
                  "particles": {
                    "stroke": {
                      "width": 0
                    },
                    "color": {
                      "value": [
                        "#ff595e",
                        "#ffca3a",
                        "#8ac926",
                        "#1982c4",
                        "#6a4c93"
                      ]
                    },
                    "number": {
                      "value": 0
                    },
                    "collisions": {
                      "enable": false
                    },
                    "opacity": {
                      "value": {
                        "min": 0.1,
                        "max": 1
                      },
                      "animation": {
                        "enable": true,
                        "speed": 0.7,
                        "sync": false,
                        "startValue": "max",
                        "destroy": "min"
                      }
                    },
                    "shape": {
                      "type": "circle"
                    },
                    "size": {
                      "value": 2,
                      "animation": {
                        "enable": false
                      }
                    },
                    "life": {
                      "count": 1,
                      "duration": {
                        "value": {
                          "min": 1,
                          "max": 2
                        }
                      }
                    },
                    "move": {
                      "enable": true,
                      "gravity": {
                        "enable": false
                      },
                      "speed": 2,
                      "direction": "none",
                      "random": true,
                      "straight": false,
                      "outMode": "destroy"
                    }
                  }
                }
              },
              "gradient": [],
              "groups": {},
              "life": {
                "count": 1,
                "delay": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0
                  },
                  "value": 0,
                  "sync": false
                },
                "duration": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0.0001
                  },
                  "value": 0,
                  "sync": false
                }
              },
              "links": {
                "blink": false,
                "color": {
                  "value": "#fff"
                },
                "consent": false,
                "distance": 100,
                "enable": false,
                "frequency": 1,
                "opacity": 1,
                "shadow": {
                  "blur": 5,
                  "color": {
                    "value": "#00ff00"
                  },
                  "enable": false
                },
                "triangles": {
                  "enable": false,
                  "frequency": 1
                },
                "width": 1,
                "warp": false
              },
              "move": {
                "angle": {
                  "offset": 0,
                  "value": 90
                },
                "attract": {
                  "distance": 200,
                  "enable": false,
                  "rotate": {
                    "x": 3000,
                    "y": 3000
                  }
                },
                "decay": 0,
                "distance": {},
                "direction": "none",
                "drift": 0,
                "enable": true,
                "gravity": {
                  "acceleration": 15,
                  "enable": true,
                  "inverse": true,
                  "maxSpeed": 100
                },
                "path": {
                  "clamp": true,
                  "delay": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0
                    },
                    "value": 0
                  },
                  "enable": false,
                  "options": {}
                },
                "outModes": {
                  "default": "destroy",
                  "bottom": "destroy",
                  "left": "destroy",
                  "right": "destroy",
                  "top": "none"
                },
                "random": false,
                "size": false,
                "speed": {
                  "min": 10,
                  "max": 20
                },
                "spin": {
                  "acceleration": 0,
                  "enable": false
                },
                "straight": false,
                "trail": {
                  "enable": true,
                  "length": 10,
                  "fillColor": {
                    "value": "#000"
                  }
                },
                "vibrate": false,
                "warp": false
              },
              "number": {
                "density": {
                  "enable": false,
                  "area": 800,
                  "factor": 1000
                },
                "limit": 0,
                "value": 0
              },
              "opacity": {
                "random": {
                  "enable": false,
                  "minimumValue": 0.1
                },
                "value": 1,
                "animation": {
                  "count": 0,
                  "enable": false,
                  "speed": 2,
                  "sync": false,
                  "destroy": "none",
                  "startValue": "random"
                }
              },
              "orbit": {
                "animation": {
                  "count": 0,
                  "enable": false,
                  "speed": 1,
                  "sync": false
                },
                "enable": false,
                "opacity": 1,
                "rotation": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0
                  },
                  "value": 45
                },
                "width": 1
              },
              "reduceDuplicates": false,
              "repulse": {
                "random": {
                  "enable": false,
                  "minimumValue": 0
                },
                "value": 0,
                "enabled": false,
                "distance": 1,
                "duration": 1,
                "factor": 1,
                "speed": 1
              },
              "roll": {
                "darken": {
                  "enable": false,
                  "value": 0
                },
                "enable": false,
                "enlighten": {
                  "enable": false,
                  "value": 0
                },
                "mode": "vertical",
                "speed": 25
              },
              "rotate": {
                "random": {
                  "enable": false,
                  "minimumValue": 0
                },
                "value": 0,
                "animation": {
                  "enable": false,
                  "speed": 0,
                  "sync": false
                },
                "direction": "clockwise",
                "path": true
              },
              "shadow": {
                "blur": 0,
                "color": {
                  "value": "#000000"
                },
                "enable": false,
                "offset": {
                  "x": 0,
                  "y": 0
                }
              },
              "shape": {
                "options": {},
                "type": "line"
              },
              "size": {
                "random": {
                  "enable": false,
                  "minimumValue": 1
                },
                "value": {
                  "min": 0.1,
                  "max": 50
                },
                "animation": {
                  "count": 0,
                  "enable": true,
                  "speed": 90,
                  "sync": true,
                  "destroy": "min",
                  "startValue": "max"
                }
              },
              "stroke": {
                "width": 1,
                "color": {
                  "value": "#ffffff",
                  "animation": {
                    "h": {
                      "count": 0,
                      "enable": false,
                      "offset": 0,
                      "speed": 1,
                      "sync": true
                    },
                    "s": {
                      "count": 0,
                      "enable": false,
                      "offset": 0,
                      "speed": 1,
                      "sync": true
                    },
                    "l": {
                      "count": 0,
                      "enable": false,
                      "offset": 0,
                      "speed": 1,
                      "sync": true
                    }
                  }
                }
              },
              "tilt": {
                "random": {
                  "enable": false,
                  "minimumValue": 0
                },
                "value": 0,
                "animation": {
                  "enable": false,
                  "speed": 0,
                  "sync": false
                },
                "direction": "clockwise",
                "enable": false
              },
              "twinkle": {
                "lines": {
                  "enable": false,
                  "frequency": 0.05,
                  "opacity": 1
                },
                "particles": {
                  "enable": false,
                  "frequency": 0.05,
                  "opacity": 1
                }
              },
              "wobble": {
                "distance": 5,
                "enable": false,
                "speed": 50
              },
              "zIndex": {
                "random": {
                  "enable": false,
                  "minimumValue": 0
                },
                "value": 0,
                "opacityRate": 1,
                "sizeRate": 1,
                "velocityRate": 1
              }
            },
            "pauseOnBlur": true,
            "pauseOnOutsideViewport": true,
            "responsive": [],
            "themes": [],
            "zLayers": 100,
            "emitters": {
              "autoPlay": true,
              "fill": true,
              "life": {
                "wait": false,
                "count": 0,
                "delay": 0.1,
                "duration": 0.1
              },
              "rate": {
                "quantity": 1,
                "delay": 0.5
              },
              "shape": "square",
              "startCount": 0,
              "size": {
                "mode": "percent",
                "height": 0,
                "width": 100
              },
              "direction": "top",
              "position": {
                "x": 50,
                "y": 100
              }
            }
          }}
        />
        )
      }
      else if (props.bgType == "portal"){
        return (
          <Particles
          container={containerRef}
          id="tsparticles"
          init={particlesInit}
          loaded={particlesLoaded}
          options={{
            "autoPlay": true,
            "background": {
              "color": {
                "value": "#000"
              },
              "image": "",
              "position": "",
              "repeat": "",
              "size": "",
              "opacity": 1
            },
            "backgroundMask": {
              "composite": "destination-out",
              "cover": {
                "color": {
                  "value": "#fff"
                },
                "opacity": 1
              },
              "enable": false
            },
            "fullScreen": {
              "enable": true,
              "zIndex": 0
            },
            "detectRetina": true,
            "duration": 0,
            "fpsLimit": 60,
            "interactivity": {
              "detectsOn": "window",
              "events": {
                "onClick": {
                  "enable": false,
                  "mode": []
                },
                "onDiv": {
                  "selectors": [],
                  "enable": false,
                  "mode": [],
                  "type": "circle"
                },
                "onHover": {
                  "enable": false,
                  "mode": [],
                  "parallax": {
                    "enable": false,
                    "force": 2,
                    "smooth": 10
                  }
                },
                "resize": true
              },
              "modes": {
                "attract": {
                  "distance": 200,
                  "duration": 0.4,
                  "easing": "ease-out-quad",
                  "factor": 1,
                  "maxSpeed": 50,
                  "speed": 1
                },
                "bounce": {
                  "distance": 200
                },
                "bubble": {
                  "distance": 200,
                  "duration": 0.4,
                  "mix": false
                },
                "connect": {
                  "distance": 80,
                  "links": {
                    "opacity": 0.5
                  },
                  "radius": 60
                },
                "grab": {
                  "distance": 100,
                  "links": {
                    "blink": false,
                    "consent": false,
                    "opacity": 1
                  }
                },
                "light": {
                  "area": {
                    "gradient": {
                      "start": {
                        "value": "#ffffff"
                      },
                      "stop": {
                        "value": "#000000"
                      }
                    },
                    "radius": 1000
                  },
                  "shadow": {
                    "color": {
                      "value": "#000000"
                    },
                    "length": 2000
                  }
                },
                "push": {
                  "default": true,
                  "groups": [],
                  "quantity": 4
                },
                "remove": {
                  "quantity": 2
                },
                "repulse": {
                  "distance": 200,
                  "duration": 0.4,
                  "factor": 100,
                  "speed": 1,
                  "maxSpeed": 50,
                  "easing": "ease-out-quad"
                },
                "slow": {
                  "factor": 3,
                  "radius": 200
                },
                "trail": {
                  "delay": 1,
                  "pauseOnStop": false,
                  "quantity": 1,
                  "particles": {
                    "color": {
                      "value": "#ff0000",
                      "animation": {
                        "enable": true,
                        "speed": 400,
                        "sync": true
                      }
                    },
                    "collisions": {
                      "enable": false
                    },
                    "links": {
                      "enable": false
                    },
                    "move": {
                      "outModes": {
                        "default": "destroy"
                      },
                      "speed": 2
                    },
                    "size": {
                      "value": 5,
                      "animation": {
                        "enable": true,
                        "speed": 5,
                        "minimumValue": 1,
                        "sync": true,
                        "startValue": "min",
                        "destroy": "max"
                      }
                    }
                  }
                }
              }
            },
            "manualParticles": [],
            "motion": {
              "disable": false,
              "reduce": {
                "factor": 4,
                "value": true
              }
            },
            "particles": {
              "bounce": {
                "horizontal": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0.1
                  },
                  "value": 1
                },
                "vertical": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0.1
                  },
                  "value": 1
                }
              },
              "collisions": {
                "bounce": {
                  "horizontal": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0.1
                    },
                    "value": 1
                  },
                  "vertical": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0.1
                    },
                    "value": 1
                  }
                },
                "enable": false,
                "mode": "bounce",
                "overlap": {
                  "enable": true,
                  "retries": 0
                }
              },
              "color": {
                "value": "#ffffff",
                "animation": {
                  "h": {
                    "count": 0,
                    "enable": false,
                    "offset": 0,
                    "speed": 1,
                    "sync": true
                  },
                  "s": {
                    "count": 0,
                    "enable": false,
                    "offset": 0,
                    "speed": 1,
                    "sync": true
                  },
                  "l": {
                    "count": 0,
                    "enable": false,
                    "offset": 0,
                    "speed": 1,
                    "sync": true
                  }
                }
              },
              "destroy": {
                "mode": "none",
                "split": {
                  "count": 1,
                  "factor": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0
                    },
                    "value": 3
                  },
                  "rate": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0
                    },
                    "value": {
                      "min": 4,
                      "max": 9
                    }
                  },
                  "sizeOffset": true
                }
              },
              "gradient": [],
              "groups": {},
              "life": {
                "count": 0,
                "delay": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0
                  },
                  "value": 0,
                  "sync": false
                },
                "duration": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0.0001
                  },
                  "value": 0,
                  "sync": false
                }
              },
              "links": {
                "blink": false,
                "color": {
                  "value": "#fff"
                },
                "consent": false,
                "distance": 100,
                "enable": false,
                "frequency": 1,
                "opacity": 1,
                "shadow": {
                  "blur": 5,
                  "color": {
                    "value": "#00ff00"
                  },
                  "enable": false
                },
                "triangles": {
                  "enable": false,
                  "frequency": 1
                },
                "width": 1,
                "warp": false
              },
              "move": {
                "angle": {
                  "offset": 0,
                  "value": 90
                },
                "attract": {
                  "distance": 200,
                  "enable": false,
                  "rotate": {
                    "x": 3000,
                    "y": 3000
                  }
                },
                "decay": 0,
                "distance": {},
                "direction": "none",
                "drift": 0,
                "enable": true,
                "gravity": {
                  "acceleration": 9.81,
                  "enable": false,
                  "inverse": false,
                  "maxSpeed": 50
                },
                "path": {
                  "clamp": true,
                  "delay": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0
                    },
                    "value": 0
                  },
                  "enable": false,
                  "options": {}
                },
                "outModes": {
                  "default": "destroy",
                  "bottom": "destroy",
                  "left": "destroy",
                  "right": "destroy",
                  "top": "destroy"
                },
                "random": false,
                "size": true,
                "speed": 5,
                "spin": {
                  "acceleration": 0,
                  "enable": false
                },
                "straight": false,
                "trail": {
                  "enable": true,
                  "length": 3,
                  "fillColor": {
                    "value": "#000000"
                  }
                },
                "vibrate": false,
                "warp": false
              },
              "number": {
                "density": {
                  "enable": false,
                  "area": 800,
                  "factor": 1000
                },
                "limit": 0,
                "value": 0
              },
              "opacity": {
                "random": {
                  "enable": false,
                  "minimumValue": 0.1
                },
                "value": {
                  "min": 0.3,
                  "max": 0.8
                },
                "animation": {
                  "count": 0,
                  "enable": false,
                  "speed": 2,
                  "sync": false,
                  "destroy": "none",
                  "startValue": "random"
                }
              },
              "orbit": {
                "animation": {
                  "count": 0,
                  "enable": false,
                  "speed": 1,
                  "sync": false
                },
                "enable": false,
                "opacity": 1,
                "rotation": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0
                  },
                  "value": 45
                },
                "width": 1
              },
              "reduceDuplicates": false,
              "repulse": {
                "random": {
                  "enable": false,
                  "minimumValue": 0
                },
                "value": 0,
                "enabled": false,
                "distance": 1,
                "duration": 1,
                "factor": 1,
                "speed": 1
              },
              "roll": {
                "darken": {
                  "enable": false,
                  "value": 0
                },
                "enable": false,
                "enlighten": {
                  "enable": false,
                  "value": 0
                },
                "mode": "vertical",
                "speed": 25
              },
              "rotate": {
                "random": {
                  "enable": false,
                  "minimumValue": 0
                },
                "value": 0,
                "animation": {
                  "enable": false,
                  "speed": 0,
                  "sync": false
                },
                "direction": "clockwise",
                "path": false
              },
              "shadow": {
                "blur": 0,
                "color": {
                  "value": "#000000"
                },
                "enable": false,
                "offset": {
                  "x": 0,
                  "y": 0
                }
              },
              "shape": {
                "options": {},
                "type": "circle"
              },
              "size": {
                "random": {
                  "enable": false,
                  "minimumValue": 1
                },
                "value": {
                  "min": 1,
                  "max": 10
                },
                "animation": {
                  "count": 0,
                  "enable": false,
                  "speed": 5,
                  "sync": false,
                  "destroy": "none",
                  "startValue": "random"
                }
              },
              "stroke": {
                "width": 0
              },
              "tilt": {
                "random": {
                  "enable": false,
                  "minimumValue": 0
                },
                "value": 0,
                "animation": {
                  "enable": false,
                  "speed": 0,
                  "sync": false
                },
                "direction": "clockwise",
                "enable": false
              },
              "twinkle": {
                "lines": {
                  "enable": false,
                  "frequency": 0.05,
                  "opacity": 1
                },
                "particles": {
                  "enable": false,
                  "frequency": 0.05,
                  "opacity": 1
                }
              },
              "wobble": {
                "distance": 5,
                "enable": false,
                "speed": 50
              },
              "zIndex": {
                "random": {
                  "enable": false,
                  "minimumValue": 0
                },
                "value": 0,
                "opacityRate": 1,
                "sizeRate": 1,
                "velocityRate": 1
              }
            },
            "pauseOnBlur": true,
            "pauseOnOutsideViewport": true,
            "responsive": [],
            "themes": [],
            "zLayers": 100,
            "emitters": {
              "autoPlay": true,
              "fill": true,
              "life": {
                "wait": false
              },
              "rate": {
                "quantity": 10,
                "delay": 0.25
              },
              "shape": "square",
              "startCount": 0,
              "size": {
                "mode": "percent",
                "height": 0,
                "width": 0
              },
              "direction": "none",
              "position": {
                "x": 50,
                "y": 50
              },
              "spawnColor": {
                "value": "#ff0000",
                "animation": {
                  "h": {
                    "count": 0,
                    "enable": true,
                    "offset": 0,
                    "speed": 5,
                    "sync": true
                  },
                  "s": {
                    "count": 0,
                    "enable": false,
                    "offset": 0,
                    "speed": 1,
                    "sync": true
                  },
                  "l": {
                    "count": 0,
                    "enable": true,
                    "offset": {
                      "min": 20,
                      "max": 80
                    },
                    "speed": 0,
                    "sync": true
                  }
                }
              }
            }
          }}
        />
        )
      }
      else if (props.bgType == "among"){
        return (
          <Particles
          container={containerRef}
          id="tsparticles"
          init={particlesInit}
          loaded={particlesLoaded}
          options={{
            "autoPlay": true,
            "background": {
              "color": {
                "value": "#000000"
              },
              "image": "",
              "position": "50% 50%",
              "repeat": "no-repeat",
              "size": "cover",
              "opacity": 1
            },
            "backgroundMask": {
              "composite": "destination-out",
              "cover": {
                "color": {
                  "value": "#fff"
                },
                "opacity": 1
              },
              "enable": false
            },
            "fullScreen": {
              "enable": true,
              "zIndex": 0
            },
            "detectRetina": true,
            "duration": 0,
            "fpsLimit": 60,
            "interactivity": {
              "detectsOn": "window",
              "events": {
                "onClick": {
                  "enable": false,
                  "mode": []
                },
                "onDiv": {
                  "selectors": [],
                  "enable": false,
                  "mode": [],
                  "type": "circle"
                },
                onHover: {
                  enable: true,
                  mode: "trail",
                  "parallax": {
                    "enable": false,
                    "force": 2,
                    "smooth": 10
                  }
                },
                "resize": true
              },
              "modes": {
                "attract": {
                  "distance": 200,
                  "duration": 0.4,
                  "easing": "ease-out-quad",
                  "factor": 1,
                  "maxSpeed": 50,
                  "speed": 1
                },
                "bounce": {
                  "distance": 200
                },
                "bubble": {
                  "distance": 200,
                  "duration": 0.4,
                  "mix": false
                },
                "connect": {
                  "distance": 80,
                  "links": {
                    "opacity": 0.5
                  },
                  "radius": 60
                },
                "grab": {
                  "distance": 100,
                  "links": {
                    "blink": false,
                    "consent": false,
                    "opacity": 1
                  }
                },
                "light": {
                  "area": {
                    "gradient": {
                      "start": {
                        "value": "#ffffff"
                      },
                      "stop": {
                        "value": "#000000"
                      }
                    },
                    "radius": 1000
                  },
                  "shadow": {
                    "color": {
                      "value": "#000000"
                    },
                    "length": 2000
                  }
                },
                "push": {
                  "default": true,
                  "groups": [],
                  "quantity": 4
                },
                "remove": {
                  "quantity": 2
                },
                "repulse": {
                  "distance": 200,
                  "duration": 0.4,
                  "factor": 100,
                  "speed": 1,
                  "maxSpeed": 50,
                  "easing": "ease-out-quad"
                },
                "slow": {
                  "factor": 3,
                  "radius": 200
                },
                trail: {
                  delay: 0.005,
                  pauseOnStop: true,
                  quantity: 1,
                  particles: {
                    color: {
                      value: "#ff0000",
                      animation: {
                        enable: true,
                        speed: 400,
                        sync: true
                      }
                    },
                    collisions: {
                      enable: false,
                      bounce: {
                        horizontal: {
                          random: {}
                        },
                        vertical: {
                          random: {}
                        }
                      },
                      overlap: {}
                    },
                    links: {
                      enable: false,
                      shadow: {},
                      triangles: {}
                    },
                    move: {
                      outModes: {
                        default: "destroy"
                      },
                      speed: 1,
                      angle: {},
                      attract: {
                        rotate: {}
                      },
                      distance: {},
                      gravity: {},
                      path: {
                        delay: {
                          random: {}
                        }
                      },
                      trail: {}
                    },
                    size: {
                      value: 5,
                      animation: {
                        enable: true,
                        speed: 5,
                        minimumValue: 1,
                        sync: true,
                        startValue: "min",
                        destroy: "max"
                      },
                      random: {}
                    },
                    bounce: {
                      horizontal: {
                        random: {}
                      },
                      vertical: {
                        random: {}
                      }
                    },
                    destroy: {
                      split: {
                        factor: {
                          random: {}
                        },
                        rate: {
                          random: {}
                        }
                      }
                    },
                    life: {
                      delay: {
                        random: {}
                      },
                      duration: {
                        random: {}
                      }
                    },
                    number: {
                      density: {}
                    },
                    opacity: {
                      animation: {},
                      random: {}
                    },
                    roll: {
                      darken: {},
                      enlighten: {}
                    },
                    rotate: {
                      animation: {}
                    },
                    shadow: {
                      offset: {}
                    },
                    shape: {},
                    stroke: {
                      color: {
                        value: "",
                        animation: {
                          count: 0,
                          enable: false,
                          offset: {
                            max: 0,
                            min: 0
                          },
                          speed: 0,
                          sync: false
                        }
                      }
                    },
                    tilt: {
                      animation: {}
                    },
                    twinkle: {
                      lines: {},
                      particles: {}
                    },
                    wobble: {}
                  }
                }
              }
            },
            "manualParticles": [],
            "motion": {
              "disable": false,
              "reduce": {
                "factor": 4,
                "value": true
              }
            },
            "particles": {
              "bounce": {
                "horizontal": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0.1
                  },
                  "value": 1
                },
                "vertical": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0.1
                  },
                  "value": 1
                }
              },
              "collisions": {
                "bounce": {
                  "horizontal": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0.1
                    },
                    "value": 1
                  },
                  "vertical": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0.1
                    },
                    "value": 1
                  }
                },
                "enable": false,
                "mode": "bounce",
                "overlap": {
                  "enable": true,
                  "retries": 0
                }
              },
              "color": {
                "value": "#fff",
                "animation": {
                  "h": {
                    "count": 0,
                    "enable": false,
                    "offset": 0,
                    "speed": 20,
                    "sync": true
                  },
                  "s": {
                    "count": 0,
                    "enable": false,
                    "offset": 0,
                    "speed": 1,
                    "sync": true
                  },
                  "l": {
                    "count": 0,
                    "enable": false,
                    "offset": 0,
                    "speed": 1,
                    "sync": true
                  }
                }
              },
              "destroy": {
                "mode": "none",
                "split": {
                  "count": 1,
                  "factor": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0
                    },
                    "value": 3
                  },
                  "rate": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0
                    },
                    "value": {
                      "min": 4,
                      "max": 9
                    }
                  },
                  "sizeOffset": true
                }
              },
              "gradient": [],
              "groups": {
                "z5000": {
                  "number": {
                    "value": 70
                  },
                  "zIndex": {
                    "value": 50
                  }
                },
                "z7500": {
                  "number": {
                    "value": 30
                  },
                  "zIndex": {
                    "value": 75
                  }
                },
                "z2500": {
                  "number": {
                    "value": 50
                  },
                  "zIndex": {
                    "value": 25
                  }
                },
                "z1000": {
                  "number": {
                    "value": 40
                  },
                  "zIndex": {
                    "value": 10
                  }
                }
              },
              "life": {
                "count": 0,
                "delay": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0
                  },
                  "value": 0,
                  "sync": false
                },
                "duration": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0.0001
                  },
                  "value": 0,
                  "sync": false
                }
              },
              "links": {
                "blink": false,
                "color": {
                  "value": "#ffffff"
                },
                "consent": false,
                "distance": 100,
                "enable": false,
                "frequency": 1,
                "opacity": 0.4,
                "shadow": {
                  "blur": 5,
                  "color": {
                    "value": "#00ff00"
                  },
                  "enable": false
                },
                "triangles": {
                  "enable": false,
                  "frequency": 1
                },
                "width": 1,
                "warp": false
              },
              "move": {
                "angle": {
                  "offset": 0,
                  "value": 10
                },
                "attract": {
                  "distance": 200,
                  "enable": false,
                  "rotate": {
                    "x": 600,
                    "y": 1200
                  }
                },
                "decay": 0,
                "distance": {},
                "direction": "right",
                "drift": 0,
                "enable": true,
                "gravity": {
                  "acceleration": 9.81,
                  "enable": false,
                  "inverse": false,
                  "maxSpeed": 50
                },
                "path": {
                  "clamp": true,
                  "delay": {
                    "random": {
                      "enable": false,
                      "minimumValue": 0
                    },
                    "value": 0
                  },
                  "enable": false,
                  "options": {}
                },
                "outModes": {
                  "default": "out",
                  "bottom": "out",
                  "left": "out",
                  "right": "out",
                  "top": "out"
                },
                "random": false,
                "size": false,
                "speed": 5,
                "spin": {
                  "acceleration": 0,
                  "enable": false
                },
                "straight": false,
                "trail": {
                  "enable": false,
                  "length": 10,
                  "fillColor": {
                    "value": "#000000"
                  }
                },
                "vibrate": false,
                "warp": false
              },
              "number": {
                "density": {
                  "enable": false,
                  "area": 800,
                  "factor": 1000
                },
                "limit": 0,
                "value": 200
              },
              "opacity": {
                "random": {
                  "enable": false,
                  "minimumValue": 0.1
                },
                "value": 1,
                "animation": {
                  "count": 0,
                  "enable": false,
                  "speed": 2,
                  "sync": false,
                  "destroy": "none",
                  "startValue": "random",
                  "minimumValue": 0.1
                }
              },
              "orbit": {
                "animation": {
                  "count": 0,
                  "enable": false,
                  "speed": 1,
                  "sync": false
                },
                "enable": false,
                "opacity": 1,
                "rotation": {
                  "random": {
                    "enable": false,
                    "minimumValue": 0
                  },
                  "value": 45
                },
                "width": 1
              },
              "reduceDuplicates": false,
              "repulse": {
                "random": {
                  "enable": false,
                  "minimumValue": 0
                },
                "value": 0,
                "enabled": false,
                "distance": 1,
                "duration": 1,
                "factor": 1,
                "speed": 1
              },
              "roll": {
                "darken": {
                  "enable": false,
                  "value": 0
                },
                "enable": false,
                "enlighten": {
                  "enable": false,
                  "value": 0
                },
                "mode": "vertical",
                "speed": 25
              },
              "rotate": {
                "random": {
                  "enable": false,
                  "minimumValue": 0
                },
                "value": 0,
                "animation": {
                  "enable": false,
                  "speed": 0,
                  "sync": false
                },
                "direction": "clockwise",
                "path": false
              },
              "shadow": {
                "blur": 0,
                "color": {
                  "value": "#000000"
                },
                "enable": false,
                "offset": {
                  "x": 0,
                  "y": 0
                }
              },
              "shape": {
                "options": {},
                "type": "circle"
              },
              "size": {
                "random": {
                  "enable": false,
                  "minimumValue": 1
                },
                "value": 3,
                "animation": {
                  "count": 0,
                  "enable": false,
                  "speed": 5,
                  "sync": false,
                  "destroy": "none",
                  "startValue": "random"
                }
              },
              "stroke": {
                "width": 0
              },
              "tilt": {
                "random": {
                  "enable": false,
                  "minimumValue": 0
                },
                "value": 0,
                "animation": {
                  "enable": false,
                  "speed": 0,
                  "sync": false
                },
                "direction": "clockwise",
                "enable": false
              },
              "twinkle": {
                "lines": {
                  "enable": false,
                  "frequency": 0.05,
                  "opacity": 1
                },
                "particles": {
                  "enable": false,
                  "frequency": 0.05,
                  "opacity": 1
                }
              },
              "wobble": {
                "distance": 5,
                "enable": false,
                "speed": 50
              },
              "zIndex": {
                "random": {
                  "enable": false,
                  "minimumValue": 0
                },
                "value": 5,
                "opacityRate": 0.5,
                "sizeRate": 1,
                "velocityRate": 1
              }
            },
            "pauseOnBlur": true,
            "pauseOnOutsideViewport": true,
            "responsive": [],
            "themes": [],
            "zLayers": 100,
            "emitters": {
              "autoPlay": true,
              "fill": true,
              "life": {
                "wait": false
              },
              "rate": {
                "quantity": 1,
                "delay": 7
              },
              "shape": "square",
              "startCount": 0,
              "size": {
                "mode": "percent",
                "height": 0,
                "width": 0
              },
              "particles": {
                "shape": {
                  "type": "images",
                  "options": {
                    "images": [
                    {
                      "src": "/graphics/10.png",
                      "width": 200,
                      "height": 300
                    },
                    {
                      "src": "/graphics/andromeda.png",
                      "width": 200,
                      "height": 300
                    },
                    {
                      "src": "/graphics/orion.png",
                      "width": 200,
                      "height": 300
                    },
                    {
                      "src": "/graphics/pleiades.png",
                      "width": 200,
                      "height": 300
                    },
                    {
                      "src": "/graphics/vega.png",
                      "width": 200,
                      "height": 300
                    },
                    {
                      "src": "/graphics/zeta.png",
                      "width": 200,
                      "height": 300
                    },
                    {
                      "src": "/graphics/78.png",
                      "width": 200,
                      "height": 200
                    }
                  ]
                  }
                },
                "size": {
                  "value": 60
                },
                "move": {
                  "speed": 8,
                  "outModes": {
                    "default": "none",
                    "right": "destroy"
                  },
                  "straight": true
                },
                "zIndex": {
                  "value": 0
                },
                "rotate": {
                  "value": {
                    "min": 0,
                    "max": 360
                  },
                  "animation": {
                    "enable": true,
                    "speed": 10,
                    "sync": true
                  }
                }
              },
              "position": {
                "x": -5,
                "y": 55
              }
            }
          }}
        />
        )
      }
     
    };

export default ParticleMotion;
